module.exports = __webpack_public_path__ + "img/delete.cb019755.svg";